import React, { Suspense, lazy } from 'react';
import styled from '@emotion/styled';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';

const TraderChatLazyComponent = lazy(() =>
    import('src/domains/players/webview/components/Account/traderChat/TraderChat').then((module) => ({
        default: module.TraderChat,
    }))
);

const TraderChatLoaderWrapper = styled('div', { label: 'TraderChatLoaderWrapper' })`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
`;

export const TraderChatLazy = (): JSX.Element => (
    <Suspense
        fallback={
            <TraderChatLoaderWrapper>
                <Loader size={24} />
            </TraderChatLoaderWrapper>
        }
    >
        <TraderChatLazyComponent />
    </Suspense>
);
